import type { ShieldProps, Shield } from 'shield-js-npm'

let shieldInstance: Shield | null = null
let initPromise: Promise<void> | null = null

export const useShield = () => {
  const config = useRuntimeConfig()

  const getShield = async () => {
    if (shieldInstance && initPromise === null) {
      return shieldInstance
    }

    if (initPromise) {
      await initPromise
      return shieldInstance!
    }

    // Dynamic import to avoid SSR issues
    const { Shield } = await import('shield-js-npm')

    shieldInstance = new Shield()

    const props: ShieldProps = {
      siteId: config.public.SHIELD_SITE_ID as string
    }

    initPromise = shieldInstance.init(props).then(() => {
      initPromise = null
    })

    await initPromise
    return shieldInstance
  }

  return {
    getShield
  }
}
